import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WalletCampaignManager from "../components/WalletCampaignManager";

const WalletAdminPage = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const backTo = new URLSearchParams(search).get("from") === "app-management" ? "/gestione-app-clienti" : "/";

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">💰 Gestione Wallet & Promo</h2>
        <button className="btn btn-outline-secondary" onClick={() => navigate(backTo)}>
          ← Torna al menu
        </button>
      </div>

      <WalletCampaignManager />

    </div>
  );
};

export default WalletAdminPage;
